import React from 'react';

import { VerifyAccount } from '../components/verify-account/verify-account';

const VerifyRoute = () => {
  return <VerifyAccount />;
};

export { VerifyRoute };
